import { tokens } from "lib/colors"
import { FC } from "react"

interface KeywordConfig {
  ID: string[]
  EN: string[]
}

interface ColoredTextProps {
  text: string
  language: "ID" | "EN"
  keywords: KeywordConfig
  color?: string
  variant?: "inline" | "block" | "inline-block" | "flex"
  coloredClassName?: string
}

const ColoredText: FC<ColoredTextProps> = ({
  text,
  language = "EN",
  keywords,
  color = tokens.accent.yellow,
  variant = "inline",
  coloredClassName = "",
}) => {
  // Get keywords for the current language
  const currentKeywords = keywords[language || "EN"]

  if (currentKeywords.length === 0) {
    return <span>{text}</span>
  }

  // Create regex pattern for all keywords
  const pattern = currentKeywords
    .map(
      (keyword) => keyword.replace(/[.*+?^${}()|[\]\\]/g, "\\$&"), // Escape regex special characters
    )
    .join("|")

  const parts = text.split(new RegExp(`(${pattern})`))

  return (
    <>
      {parts.map((part: string, index: number) => {
        if (currentKeywords.includes(part)) {
          return (
            <span
              className={`${coloredClassName || variant}`}
              key={index}
              style={{ color }}>
              {part}
            </span>
          )
        }
        return <span key={index}>{part}</span>
      })}
    </>
  )
}

export default ColoredText
